import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from 'react-redux';
import * as S from '../scss/theme';
import fnc from "../mymod/commFunction";
import './Login1_where.scss';
import HongButton from "../comm/HongButton";
import { motion } from 'framer-motion';

import img_arrowDown from '../images/flation/arrow-down.png';
import SignUp_aca from './SignUp_aca';
import { useNavigate } from "react-router-dom";
import { setIsLoggedIn, setUserInfo, setUserName, setUserKind, setIsStudent, setIsAdmin } from "../reduxToolkit/reduxIgong";

const Login1_where = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const userkind = useSelector((state => state.reduxIgong.userKind));
    const isStudent = useSelector((state) => state.reduxIgong.isStudent);

    const [activeIndex, setActiveIndex] = useState(-1);
    const [activeIndex_acaSt, setActiveIndex_acaSt] = useState(-1);
    const [activeIndex_schSt, setActiveIndex_schSt] = useState(-1);
    const [activeIndex_homeSt, setActiveIndex_homeSt] = useState(-1);

    const userIdRef = useRef(null);  // useRef 훅을 사용해 참조 생성
    const [userId, setUserId] = useState('');
    const [password, setPassword] = useState('');

    const handleClick = (index) => {
      setActiveIndex(index);
    };

    const handleClick_acaSt = (index) => {
        setActiveIndex_acaSt(index);
    };

    const handleClick_schSt = (index) => {
        setActiveIndex_schSt(index);
    };

    const handleClick_homeSt = (index) => {
        setActiveIndex_homeSt(index);
    };


    function handleLogin() {
        if (activeIndex === -1) {
            alert('대상을 선택하세요!');
            return;
        }

        let routeStr = '';

        if (activeIndex === 0) {//학원

           switch(activeIndex_acaSt) {
            case 0://학원장
                routeStr = '/loginRoutes/select/login_aca';    
                break;
            case 1://학원강사
                routeStr = '/loginRoutes/select/login_aca_tec';
                break;
            case 2://학원학생
                routeStr = '/loginRoutes/select/login_aca_stu';
                break;
           }

           fncBasicLogin(routeStr, userId, password);
        }
    
        if (activeIndex === 1) {//학교

            switch(activeIndex_schSt) {
                case 0://학교관리자
                    routeStr = '/loginRoutes/select/login_sch';    
                    break;
                case 1://학교교사
                    routeStr = '/loginRoutes/select/login_sch_tec';
                    break;
                case 2://학교학생
                    routeStr = '/loginRoutes/select/login_sch_stu';
                    break;
            }

          
            fncBasicLogin(routeStr, userId, password);
        }
    
        if (activeIndex === 2) {
            switch(activeIndex_homeSt) {
                case 0://개인 학부모
                    routeStr = '/loginRoutes/select/login_mom';
                    break;
                case 1://개인 학생
                    routeStr = '/loginRoutes/select/login_mom_stu';
                    break;    
            }

            fncBasicLogin(routeStr, userId, password);
        }

    }
 
   

    
  function fncBasicLogin(routeStr, userId, password) {
     fnc.sendAxios(`${routeStr}`, { userId, password }, (res) => {
      if (res.length) {
        const userKind = res[0].userKind;
        const userKind2 = res[0].userKind2;

        dispatch(setUserInfo(res[0]));
     
        dispatch(setUserName(res[0].userName));
        dispatch(setUserKind(userKind));
        dispatch(setIsStudent(userKind2 === '학생'));

        dispatch(setIsLoggedIn(true));
        dispatch(setIsAdmin(false));

        switch (userKind) {
            case '학원원장':
                navigate('/myRoomAca'); 
                break;
            case '학원강사':
                navigate('/myRoomAcaTec'); 
                break;
            case '학원학생':
                navigate('/myRoomAcaStu'); 
                break;
            case '학교관리자':
                navigate('/myRoomSch'); 
                break;

            case '학교교사':
                navigate('/myRoomSchTec'); 
                break;
            case '학교학생':
                navigate('/myRoomSchStu'); 
                break;
            case '개인학부모':
                navigate('/myRoomMom'); 
                break;
            case '개인학생':
                navigate('/myRoomMomStu'); 
                break;
        }

       

      } else {
        alert('정보가 올바르지 않습니다.')
      }
    });
  }


  function handleSingup() {
    if (activeIndex === -1) {
        alert('대상을 선택하세요!');
        return;
    }

    if (activeIndex === 0) {
        navigate('/signupAca');
    }

    if (activeIndex === 1) {
        navigate('/signupSchool');
    }

    if (activeIndex === 2) {
        navigate('/signupIndividual');
    }
}


    //=============================================
    return (
        <S.Section>
            <div className="Login1_where">
                <div className='wrap-main'>
                <section className='sec-main1'>
                    <article className='art-main1'>
                        <p className="heading-2">어디서 오셨습니까? </p>
                        <ul>
                                {["학원", "학교", "개인"].map((item, index) => (
                                <li
                                    key={index}
                                    onClick={() => handleClick(index)}
                                    className={activeIndex === index ? "active" : ""}
                                    >
                                    {item}
                                </li>
                            ))}
                        </ul>
                    </article>

                   {activeIndex === 0 && <article className='art-main1'>
              
                        <ul>
                                {["원장", "강사", "학생"].map((item, index) => (
                                <li
                                    key={index}
                                    onClick={() => handleClick_acaSt(index)}
                                    className={activeIndex_acaSt === index ? "activeSt" : ""}
                                    >
                                    {item}
                                </li>
                            ))}
                        </ul>
                    </article> }

                    {activeIndex === 1 && <article className='art-main1'>
                        <ul>
                                {["관리자", "교사", "학생"].map((item, index) => (
                                <li
                                    key={index}
                                    onClick={() => handleClick_schSt(index)}
                                    className={activeIndex_schSt === index ? "activeSt" : ""}
                                    >
                                    {item}
                                </li>
                            ))}
                        </ul>
                    </article>}

                    {activeIndex === 2 && <article className='art-main1'>
                        <ul>
                                {["학부모", "학생"].map((item, index) => (
                                <li
                                    key={index}
                                    onClick={() => handleClick_homeSt(index)}
                                    className={activeIndex_homeSt === index ? "activeSt" : ""}
                                    >
                                    {item}
                                </li>
                            ))}
                        </ul>
                    </article>}


                    <article className='art-main2'>
                        <p className="heading-3">클릭 후 </p>

                        <div className='box-motion'>
                            <motion.img
                                src={img_arrowDown}
                                initial={{ y: 0 }}
                                animate={{ y: [-10, 10, -12], }}
                                transition={{ duration: 1, ease: 'easeInOut',  repeat: Infinity, }}
                            />
                        </div>

                       
                    </article>

                    <article className="art-login">
                        <div> 
                            <label htmlFor="userId">* 아이디</label>
                            <input
                                type="text"
                                id="userId"
                                ref={userIdRef}  // input 요소에 ref 속성을 설정
                                value={userId}
                                onChange={(e) => setUserId(e.target.value)}
                                spellCheck='false'
                            />
                        </div>

                        <div>
                            <label htmlFor="password">* 비밀번호</label>
                            <input
                                type="password"
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </div>
                    </article>

                    <article className='art-main3'>
                    
                       <HongButton className="h-btn-red btn" onClick={handleLogin}>로그인</HongButton>
                        {(  (activeIndex === 0 && activeIndex_acaSt === 0) || 
                            (activeIndex === 1 && activeIndex_schSt === 0) || 
                            (activeIndex === 2 && activeIndex_homeSt === 0)) && 
                        <HongButton className="h-btn-blue btn" onClick={handleSingup}>회원가입</HongButton>
                        }
                       
                    </article>

                </section>

            
                </div>
            </div>
        </S.Section>
    );
};

export default Login1_where;
